import { useListAllPlatformsMinimal } from '@b7hio/api-lib/src/ops-portal';
import { FormAutocomplete } from '@b7hio/core-lib/src/components/Form/FormAutocomplete/FormAutocomplete';
import type { TextFieldProps } from '@mui/material';
import { CircularProgress } from '@mui/material';
import { DateTime } from 'luxon';
import React from 'react';
import type { UseControllerProps } from 'react-hook-form';
import type { FieldValues } from 'react-hook-form';
import type { TFunction } from 'i18next';

type Props<T extends FieldValues> = UseControllerProps<T> & {
  readonly label: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  readonly t: TFunction<any>;
  readonly disabled?: boolean;
  readonly size?: TextFieldProps['size'];
};

const staleTime = DateTime.fromSeconds(60).toMillis();

export function FormPlatformList<T extends FieldValues = FieldValues>(
  props: Props<T>
) {
  const { data, isLoading, refetch, isStale } = useListAllPlatformsMinimal({
    query: {
      staleTime,
    },
  });

  const platforms =
    data?.map((platform) => ({
      label: platform.tradingName,
      value: platform.uid,
    })) ?? [];

  return (
    <FormAutocomplete
      options={platforms}
      isOptionEqualToValue={(o1, o2) => o1.value === o2.value}
      loading={isLoading}
      onOpen={() => isStale && refetch()}
      InputProps={(InputProps) => ({
        ...InputProps,
        endAdornment: (
          <React.Fragment>
            {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
            {InputProps.endAdornment}
          </React.Fragment>
        ),
      })}
      {...props}
    />
  );
}
